import { render, staticRenderFns } from "./MdPatientDiagnosis.vue?vue&type=template&id=3f2bd26c&"
import script from "./MdPatientDiagnosis.vue?vue&type=script&lang=js&"
export * from "./MdPatientDiagnosis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports